export default[
    {name:"boliviana"},
    {name:"brasileña"},
    {name:"argentina"},
    {name:"chilena"},
    {name:"peruana"},
    {name:"venezolana"},
    {name:"colombiana"},
    {name:"cubana"},
    {name:"mexicana"},
    {name:"ecuatoriana"},
    {name:"panameña"},
    {name:"uruguaya"},
    {name:"canadiense"},
    {name:"estadounidense"},
    {name:"antiguana"},
    {name:"bahameña"},
    {name:"barbadense"},
    {name:"beliceña"},
    {name:"costarricense"},
    {name:"dominiqués"},
    {name:"dominicana"},
    {name:"granadina"},
    {name:"groenlandés"},
    {name:"guatemalteca"},
    {name:"guañana"},
    {name:"haitiana"},
    {name:"hondureña"},
    {name:"jamaicana"},
    {name:"nicaraguense"},
    {name:"paraguaya"},
    {name:"salvadoreña"},
    {name:"surinamés"},
    {name:"sanvicentina"},
    {name:"albana"},
    {name:"andorrana"},
    {name:"belga"},
    {name:"bosnia"},
    {name:"británica"},
    {name:"búlgara"},
    {name:"danés"},
    {name:"alemana"},
    {name:"estonia"},
    {name:"finés"},
    {name:"francés"},
    {name:"griega"},
    {name:"irlandés"},
    {name:"islandés"},
    {name:"italiana"},
    {name:"croata"},
    {name:"letonia"},
    {name:"liechtensteiniana"},
    {name:"lituana"},
    {name:"luxemburgés"},
    {name:"maltés"},
    {name:"macedonia"},
    {name:"moldava"},
    {name:"monaqués"},
    {name:"montenegrina"},
    {name:"holandés"},
    {name:"noruega"},
    {name:"austriaca"},
    {name:"polaca"},
    {name:"portugués"},
    {name:"rumana"},
    {name:"rusa"},
    {name:"sanmarinense"},
    {name:"sueca"},
    {name:"suiza"},
    {name:"serbia"},
    {name:"eslovaca"},
    {name:"eslovaca"},
    {name:"español"},
    {name:"checa"},
    {name:"turca"},
    {name:"ucraniana"},
    {name:"húngara"},
    {name:"vaticana"},
    {name:"bielorusa"},
    {name:"greco-chipriota"},
    {name:"chipriota"},
    {name:"egipcia"},
    {name:"argelina"},
    {name:"angolana"},
    {name:"ecuatoguineana"},
    {name:"etíope"},
    {name:"beninés"},
    {name:"botsuana"},
    {name:"burkinés"},
    {name:"burundés"},
    {name:"eritrea"},
    {name:"gabonés"},
    {name:"gambiana"},
    {name:"ghanés"},
    {name:"guineana"},
    {name:"marfileña"},
    {name:"camerunés"},
    {name:"caboverdiana"},
    {name:"keniata"},
    {name:"comorense"},
    {name:"congoleña"},
    {name:"lesotense"},
    {name:"liberiana"},
    {name:"libia"},
    {name:"malgache"},
    {name:"malauí"},
    {name:"maliense"},
    {name:"marroquí"},
    {name:"mauritana"},
    {name:"mauriciana"},
    {name:"mozambiqueña"},
    {name:"namibia"},
    {name:"nigeriana"},
    {name:"ruandés"},
    {name:"zambiana"},
    {name:"senegalés"},
    {name:"seychelense"},
    {name:"sierraleonés"},
    {name:"zimbabuense"},
    {name:"somalí"},
    {name:"sudafricana"},
    {name:"sudanés"},
    {name:"suazi"},
    {name:"tanzana"},
    {name:"togolés"},
    {name:"chadiana"},
    {name:"tunecina"},
    {name:"ugandés"},
    {name:"centroafricana"},
    {name:"laosiana"},
    {name:"libanés"},
    {name:"afgana"},
    {name:"armenia"},
    {name:"azerbaiyana"},
    {name:"bareiní"},
    {name:"bangladesí"},
    {name:"bruneana"},
    {name:"china"},
    {name:"georgiana"},
    {name:"india"},
    {name:"indionisia"},
    {name:"iraquí"},
    {name:"iraní"},
    {name:"israelí"},
    {name:"japonés"},
    {name:"jemení"},
    {name:"jordana"},
    {name:"camboyana"},
    {name:"kazaja"},
    {name:"katarí"},
    {name:"kirguís"},
    {name:"kuwaití"},
    {name:"malaya"},
    {name:"maldiva"},
    {name:"mongól"},
    {name:"birmana"},
    {name:"norcoreana"},
    {name:"omanés"},
    {name:"pakistaní"},
    {name:"filipina"},
    {name:"saudí"},
    {name:"singapurense"},
    {name:"ceilandés"},
    {name:"surcoreana"},
    {name:"siria"},
    {name:"tailandés"},
    {name:"timorense"},
    {name:"uzbeca"},
    {name:"vietnamita"},
    {name:"australiana"},
    {name:"kiribatiana"},
    {name:"marshalés"},
    {name:"nauruana"},
    {name:"neozelandés"},
    {name:"niuana"},
    {name:"papú"},
    {name:"salomonense"},
    {name:"samoana"},
    {name:"tongana"},
    {name:"tuvaluana"},
    {name:"vanuatuense"}
];


// WEBPACK FOOTER //
// ./src/utils/Nationality/nationalities.js